<template>
    <div class="gift-payment">
        <div class="gift-payment-page">
            <div class="title">
                Payment Information
            </div>
            <div class="detail">
                This is a secure 128-bit SSL encrypted payment
            </div>
            <div class="payment-type">
                <el-collapse v-model="activeName" accordion>
                    <el-collapse-item name="1" class="paypal-collapse">
                        <template #title>
                            <el-radio label="paypal" class="paypal" v-model="type">
                                <img src="../assets/img/gift/icon-paypal.png">
                            </el-radio>
                        </template>
                        <div class="card-content">Paypal <br>content<br>content</div>
                    </el-collapse-item>
                    <el-collapse-item name="2" class="card-collapse">
                        <template #title>
                            <el-radio label="card" class="card" v-model="type">
                                <p class="card-text">Credit Card</p>
                                <p align="right" class="credit-cards">
                                    <img src="../assets/img/gift/icon-mastercard.png">
                                    <img src="../assets/img/gift/icon-visa.png">
                                    <img src="../assets/img/gift/icon-discover.png">
                                    <img src="../assets/img/gift/icon-ae.png">
                                </p>
                            </el-radio>
                        </template>
                        <div class="card-content">
                            <div class="card-content-item">
                                <div class="title"><span class="mandatory">*</span>Card Number</div>
                                <div class="input"><el-input v-model="form.number" placeholder="1234 1234 1234 1234"/></div>
                            </div>
                            <div class="card-content-item medium left">
                                <div class="title"><span class="mandatory">*</span>Expiration Date</div>
                                <div class="input"><el-input v-model="form.expiry" placeholder="MM/YY" /></div>
                            </div>
                            <div class="card-content-item medium">
                                <div class="title">
                                    <span class="mandatory">*</span>
                                    CVC Code
                                    <i class="el-icon-question" @click="cvcDialog = true"></i>
                                </div>
                                <div class="input"><el-input v-model="form.cvc" placeholder="CVC"/></div>
                            </div>
                            <div class="checkbox">
                                <div class="checkbox-square">
                                    <el-checkbox v-model="form.checked" />
                                </div>
                                <div class="checkbox-label">
                                    Save my billing info for future purchases.
                                </div>
                            </div>
                            <div class="button">
                                <el-button @click="handleCheckout">Check out</el-button>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <el-dialog
            title="CVC Code"
            v-model="cvcDialog"
            custom-class="cvcDialog">
            <img src="../assets/img/cvc.png" >
        </el-dialog>
        <div v-if="showResult==true" class="result-modal">
            <el-dialog v-model="showResult" width="920px" :close-on-click-modal="false" center>
                <span><img src="../assets/img/gift/Successful.png"></span>
                <div class="title">
                    Payment Successful
                </div>
                <div class="detail">
                    Thank you for your payment, your transaction was successful.
                </div>
                <div class="refresh">
                    This page will refresh to homepage automatically in 5 second.
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Gift Payment",
        data() {
            return {
                activeName: '2',
                type: 'card',
                showResult: false,
                form:{
                    number: '',
                    expiry: '',
                    cvc: ''
                },
                time: 5,
                cvcDialog: false,
            }
        },
        methods: {
            handleCheckout(){
                this.showResult = true;
                setInterval(this.countDown, 1000);
            },

            countDown(){
                this.time--;
            }
        },
        watch: {
            'type'() {
                if(this.type=='card'){
                    this.activeName = '2'
                } else{
                    this.activeName = '1'
                }
            },

            time: function(val){
                if(val == 0){
                    this.$router.push({path: '/gift/home'});
                }
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/GiftPayment.scss";
    @import "../styles/mobile/GiftPayment.scss";
</style>
